/**************************************************
 * Nombre:       Seccion_Sostenibilidad
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import Equipo from "./Componentes/Equipo";
import Adicional_Portada from "./Componentes/Adicional_Portada";
import {useParams} from "react-router-dom";
import {useEffect, useState} from "react";
import {obtenerDoc} from "../../Servicios/BD/obtenerDoc";
import Adicional_Contenido from "./Componentes/Adicional_Contenido";
import {irArriba} from "../../Utilidades/irArriba";

const Seccion_Adicional = () => {
    const parms = useParams()
    const [item, setItem] = useState({})

    useEffect(() => {

        irArriba()

        setItem({})

        if (parms && parms.id) {
            obtenerDoc('adicionales', parms.id).then((dox) => {
                if (dox.res) {
                    setItem(dox.data)
                }
            })
        }

    }, [parms]);
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Adicional_Portada item={item}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 6}}>
                <Adicional_Contenido item={item}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 10}}>
                <Equipo/>
            </Grid>

        </Grid>
    )

}
export default Seccion_Adicional